import React from "react";
import { Route, Routes, useParams } from "react-router-dom";

import {
  ScrollToTopOnMount,
  useQueryGetClassroom,
} from "@examspark/common-app";

import Classroom from "../../components/classroom/Classroom";
import ClassroomProvider from "../../contexts/ClassroomProvider";

import ClassroomUnitRoute from "./ClassroomUnitRoute";

const ClassroomRoute = () => {
  const params = useParams<{
    id: string;
  }>();

  const { data: classroom, refetch } = useQueryGetClassroom(params.id);

  return (
    <ClassroomProvider classroom={classroom}>
      <ScrollToTopOnMount />
      <Routes>
        <Route
          path="/unit/:unitId/*"
          element={<ClassroomUnitRoute classroom={classroom} />}
        />
        <Route
          path="*"
          element={
            <Classroom classroom={classroom} onUpdate={() => refetch()} />
          }
        />
      </Routes>
    </ClassroomProvider>
  );
};

export default ClassroomRoute;
